import { Scene, TextureLoader } from "three";
import { Environment, IEnvironmentConfig } from "./Environment";
import { Collection } from "../utils/Collection";
import { EnvironmentSelector } from "./EnvironmentSelector";
import { Main } from "../Main";

export class EnvironmentManager
{
	private _scene: Scene;

	private _environment: Environment;
	private _environments: Collection<Environment>;
	private _selector: EnvironmentSelector;
	private _textureLoader: TextureLoader;

	constructor(scene: Scene)
	{
		this._scene = scene;
		this._textureLoader = new TextureLoader();

		this.createEnvironments();

		this._selector = new EnvironmentSelector(this._environments);
		this._selector.changeSignal.add(this.onEnvironmentChange, this);
	}

	public async init()
	{
		await this.onEnvironmentChange();
	}

	private createEnvironments()
	{
		var configs: IEnvironmentConfig[] = Main.getInstance().config.config.scenes;
		var environments: Environment[] = [];

		for (var i = 0; i < configs.length; ++i)
		{
			var config = configs[i];

			var environment = new Environment(config, this._scene, this._textureLoader);
			environments.push(environment);
		}

		this._environments = new Collection(environments);
	}

	private async onEnvironmentChange(environmentId?: string)
	{
		if (this._environment)
		{
			this._environment.hide();
		}

		this._environment = this._selector.value;

		if (this._environment)
		{
			await this._environment.show();
		}
	}

	public get environment()
	{
		return this._environment;
	}
}